import { render, staticRenderFns } from "./insertOrUpdate.vue?vue&type=template&id=6b18bc81"
import script from "./insertOrUpdate.vue?vue&type=script&lang=js"
export * from "./insertOrUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports